module.exports = __webpack_public_path__ + "img/complexe_les_ailes.31b2c560.webp";